import React from 'react'

import Preloader from '~components/ReceiveWidget/ReceiveFiat/IbanReceiveFiat/Preloader'

function SkeletonFiat() {
    return <Preloader />
}

export default SkeletonFiat
